import { useGtag } from 'vue-gtag-next'
import { computed } from 'vue'
// import { useUserStore } from '@/stores/user'

export function useGoogleAnalytics() {
  const { event } = useGtag()
//   const store = useUserStore()

//   const ipAddress = computed(() => {
//     return store.clientInfo.ip_address
//   })
  const storageUser = computed(() => {
    return localStorage.getItem('user')
  })

//   function gTrackQuestionFaq(id) {
//     event('click_question_faq', {
//       event_category: 'faq',
//       event_label: `#question-${id}`,
//       event_value: ipAddress.value,
//     })
//   }

  function gTrackUpdatePageBtn() {
    event('click_button_protocols_reload_page', {
      event_category: 'protocols',
      event_label: '#button-protocols-reload-page',
      event_value: 1,
      // event_value: user["token"],
    })
  }

  function gTrackChangeUserStatus() {
    let user = null;
    user = JSON.parse(storageUser.value);

    event('click_button_change_user_status', {
      event_category: 'header',
      event_label: '#button-change-user-status',
      event_value: user["token"],
    })
  }

  return {
    gTrackUpdatePageBtn,
    gTrackChangeUserStatus,
  }
}